import { Button, Drawer, Card, Typography, Empty } from "antd";
import React, { useEffect, useState } from "react";

const { Text } = Typography;

const TransferDrawer = ({ selectedService, visible, onClose }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!selectedService?.entries) {
      setData([]);
      return;
    }

    const entries = selectedService.entries.filter((e) => e?.product.product_for_service !== null);

    setData(entries);
  }, [selectedService]);

  if (!selectedService) return null;

  return (
    <Drawer
      title="Consultas com Transfer"
      open={visible}
      onClose={onClose}
      size={720}
      destroyOnHidden
      styles={{
        body: {
          paddingBottom: 80,
          overflowY: "auto",
        },
      }}
      footer={
        <div
          style={{
            position: "sticky",
            bottom: 0,
            background: "#fff",
            padding: "12px 16px",
            textAlign: "right",
          }}
        >
          <Button size="large" type="primary" onClick={onClose}>
            Fechar
          </Button>
        </div>
      }
    >
      {data.length === 0 ? (
        <Empty description="Sem Transfer" />
      ) : (
        data.map((entry) => {
          const paxTotal =
            entry?.passengersList?.reduce((acc, p) => {
              return acc + (p?.pax_i || 0) + (p?.pax_m || 0) + (p?.pax_z || 0);
            }, 0) || 0;

          return (
            <Card key={entry._id} style={{ marginBottom: 12 }}>
              <Text strong>
                {entry?.product?.name || "—"} - Consulta: {entry?.entry_id_raw || "—"}
              </Text>

              <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 8 }}>
                <Text type="secondary" style={{ minWidth: 60 }}>
                  Cliente:
                </Text>
                <Text>{entry?.passenger?.name || entry?.entity?.name || "—"}</Text>
              </div>

              <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 4 }}>
                <Text type="secondary" style={{ minWidth: 60 }}>
                  PAX:
                </Text>
                <Text>{paxTotal} </Text>
              </div>
            </Card>
          );
        })
      )}
    </Drawer>
  );
};

export default TransferDrawer;
